import { LoadingScreen } from '@/features/common/components/LoadingScreen';
import { NotFound } from '@/features/common/components/NotFound';
import AccountRoute from '@/hocs/AccountRoute';
import AdminRoute from '@/hocs/AdminRoute';
import ErrorBoundary from '@/hocs/ErrorBoundary';
import ProtectedRoute from '@/hocs/ProtectedRoute';
import RootWrapper from '@/hocs/RootWrapper';
import Root from '@/pages/root/page';
import accountRoutes from '@/routes/account.routes';
import adminRoutes from '@/routes/admin.routes';
import { Navigate, RouteObject } from 'react-router-dom';

const routes: RouteObject[] = [
  {
    element: <RootWrapper />,
    errorElement:
      import.meta.env.VITE_APP_ENV === 'production' ? <ErrorBoundary /> : null,
    hydrateFallbackElement: <LoadingScreen />,
    children: [
      // Public Routes
      {
        path: '/logout/callback',
        lazy: () => import('@/pages/(public)/logout/callback')
      },
      // Protected Routes
      {
        element: <ProtectedRoute />,
        children: [
          {
            index: true,
            element: <Root />
          },
          {
            element: <AccountRoute />,
            children: accountRoutes
          },
          {
            element: <AdminRoute />,
            children: adminRoutes
          },
          {
            path: '/login',
            element: <Navigate to="/" />
          },
          {
            path: '*',
            element: <NotFound />
          }
        ]
      }
    ]
  }
];

export default routes;
